import { Getter } from "vuex";
import { IState, ISearchHits } from "./state";

const title: Getter<IState, IState> = (state) => state.title;
const preamble: Getter<IState, IState> = (state) => state.preamble;
const searchResult: Getter<IState, IState> = (state) => state.searchResult;
const hits: Getter<IState, IState> = (state) => state.searchResult.searchHits;
const areaFilter: Getter<IState, IState> = (state) => state.areaFilter;
const statusFilter: Getter<IState, IState> = (state) => state.statusFilter;
const filteredHits: Getter<IState, IState> = (state) => {
  const filtered: ISearchHits = {};
  const selectedAreas = state.areaFilter.filter((filter) => filter.selected);
  const selectedStatuses = state.statusFilter.filter(
    (filter) => filter.selected
  );
  const hasActiveFilters =
    selectedAreas.length > 0 || selectedStatuses.length > 0;
  const areas = Object.keys(state.searchResult.searchHits);

  if (!hasActiveFilters) {
    areas.sort((first, second) => first.localeCompare(second, "sv"));
  }

  areas.forEach((area) => {
    const areaMatches =
      selectedAreas.length === 0 ||
      selectedAreas.some((filter) => filter.name === area);

    if (!areaMatches) {
      return;
    }

    const matchingHits = state.searchResult.searchHits[area].filter((hit) => {
      return (
        selectedStatuses.length === 0 ||
        selectedStatuses.some((filter) => filter.name === hit.status)
      );
    });

    if (matchingHits.length > 0) {
      filtered[area] = matchingHits;
    }
  });

  return filtered;
};
const showMore: Getter<IState, IState> = (state) => {
  //Kolla på summan av sidor på aktiva filters
  // if amountOfShowingHits < den summan
  let sum = 0;
  let showingHits = state.currentlyShowingHits;
  Object.keys(showingHits).forEach((key) => {
    sum += showingHits[key].length;
  });
  return state.amountOfShowingHits < sum;
};
const totalHits: Getter<IState, IState> = (state) =>
  state.searchResult.totalHits;
const showingHits: Getter<IState, IState> = (state) =>
  state.amountOfShowingHits;
const query: Getter<IState, IState> = (state) => state.query;
const shouldFocus: Getter<IState, IState> = (state) => state.focus.shouldFocus;
const focusIndex: Getter<IState, IState> = (state) => state.focus.index;
const hitsPerPage: Getter<IState, IState> = (state) => state.hitsPerPage;
const searchedQuery: Getter<IState, IState> = (state) => state.searchedQuery;
const suggestion: Getter<IState, IState> = (state) => state.suggestion;
const translations: Getter<IState, IState> = (state) => state.translations;
const currentPage: Getter<IState, IState> = (state) => state.currentPage;
const count: Getter<IState, IState> = (state) => state.count;
const amountOfShowingHits: Getter<IState, IState> = (state) =>
  state.amountOfShowingHits;
const currentlyShowingHits: Getter<IState, IState> = (state) =>
  state.currentlyShowingHits;

export default {
  title,
  preamble,
  searchResult,
  hits,
  areaFilter,
  statusFilter,
  filteredHits,
  showMore,
  totalHits,
  showingHits,
  query,
  shouldFocus,
  hitsPerPage,
  focusIndex,
  searchedQuery,
  suggestion,
  translations,
  currentPage,
  amountOfShowingHits,
  count,
  currentlyShowingHits,
};
